import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../redux-stores/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { APP_URL } from "../constants/constants";
import { persistor } from "../redux-stores/store";

const Logout:React.FC = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        persistor.purge();
        dispatch(logout());
        window.location.href = APP_URL+'/login'
    }, [dispatch, navigate])

    return null;
}

export default Logout